import React from "react";
import LandingPage from "./LandingPage";

// Serves the original Storyteller landing page at /legacy now that the new
// ArtCraft promo lives at the root path.
export default function LegacyLandingPage() {
  return <LandingPage legacy={true} />;
}
